import { render, staticRenderFns } from "./cargandoWebMovil.vue?vue&type=template&id=b4bda924&scoped=true&"
import script from "./cargandoWebMovil.vue?vue&type=script&lang=js&"
export * from "./cargandoWebMovil.vue?vue&type=script&lang=js&"
import style0 from "./cargandoWebMovil.vue?vue&type=style&index=0&id=b4bda924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bda924",
  null
  
)

export default component.exports